// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    {{#if showLabel}}
    <terceraLabel visible="{{visible}}" text="{{label}}" />
    {{/if}}

    <div class="oe-selector-right">
        <terceraComboBox showLastValue="{{showLastValue}}"
                         items="{{items}}"
                         selectedItem="{{selectedItem}}"
                         tooltip="{{tooltip}}"
                         visible="{{visible}}"
                         enabled="{{enabled}}" />
    </div>
</div>`;
// Exports
export default code;